import cx from 'classnames';

import TradeFeeContent from 'components/placeorder/partials/makerTakerPopup/TradeFeeContent';
import Render from 'components/render';
import useWalletIndianExchange from 'hooks/componentHooks/useWalletIndianExchange';
import i18n from 'i18n/config';

import styles from './indianWallet.module.scss';
import TooltipWrapper from './TooltipWrapper';

const deltaCashLabel = i18n.t('headerFooter:header.wallet.deltaCash');
const deltaCashPopOver = <TradeFeeContent />;

const DeltaCash = ({ showAmount }: { showAmount: boolean }) => {
  const { deltaCash } = useWalletIndianExchange();

  return (
    (<div
      className={cx(
        styles['label-value-container'],
        styles.accountValueCollapsableButton
      )}
      data-palette="DeltaCash">
      <div className={styles.label}>
        <TooltipWrapper title={deltaCashLabel} body={deltaCashPopOver} />
      </div>
      <div className={cx('flex-set flex--column', styles.value)}>
        <span className={styles.inr}>
          <Render when={showAmount} else="******">
            {deltaCash.deltaCashFormattedInINR}
          </Render>
        </span>
        <span className={styles.usd}>
          <Render when={showAmount} else="******">
            {deltaCash.deltaCashFormattedInUSD}
          </Render>
        </span>
      </div>
    </div>)
  );
};

export default DeltaCash;
